import React, { useEffect } from "react";
import { useTransferModel } from "./transferModel";
import { YhBox } from "@/components/YhBox";
import { TransferDataTable } from "./DataTable";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";

export const TransferDataBox = () => {
    const {
        loadData,
        transferAmountData
        // dataSource,
        // selectedRowKeys,
        // setSelectedData,
    } = useTransferModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    // useEffect(() => {
    //     let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    //     const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    //     setSelectedData(selectedData)
    // }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "转入总额",
            value: transferAmountData.totalInAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
        {
            label: "转出总额",
            value: transferAmountData.totalOutAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.red
        },
    ]

    return (
        <>
            <YhBox title={"转账记录"} descriptions={desc}>
                <TransferDataTable />
            </YhBox>
        </>
    )
}
